document.addEventListener('DOMContentLoaded', () => {
  const loadMoreBtn = document.getElementById('LoadMoreButton');
  if (!loadMoreBtn) return;

  const productGrid = document.getElementById('product-grid');

  const setButtonText = (text) => {
    // Keep the SVG, only update the text node
    const svg = loadMoreBtn.querySelector('svg'); // assumes your arrow is an <svg>
    loadMoreBtn.textContent = text; // reset text
    if (svg) loadMoreBtn.appendChild(svg); // re-add the SVG
  };

  loadMoreBtn.addEventListener('click', async () => {
    const nextUrl = loadMoreBtn.dataset.nextUrl;
    if (!nextUrl) return;

    loadMoreBtn.disabled = true;
    setButtonText('Loading…');

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();

      const html = document.createElement('div');
      html.innerHTML = text;

      const newProducts = html.querySelectorAll('#product-grid > *');
      newProducts.forEach(product => {
        productGrid.appendChild(product);
      });

      const newLoadMoreBtn = html.querySelector('#LoadMoreButton');

      if (newLoadMoreBtn && newLoadMoreBtn.dataset.nextUrl) {
        loadMoreBtn.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
        loadMoreBtn.disabled = false;
        setButtonText('Load more'); // keep SVG
      } else {
        loadMoreBtn.remove();
      }
    } catch (error) {
      console.error('Load more error:', error);
      loadMoreBtn.disabled = false;
      setButtonText('Load more'); // keep SVG
    }
  });
});
